export const ADD_TIMER_HIDE_SCORECARD = "ADD_TIMER_HIDE_SCORECARD";
export const SET_BOWLING_CENTER_TO_HIDE = "SET_BOWLING_CENTER_TO_HIDE";
export const SET_LAST_PLAYER_UPDATED = "SET_LAST_PLAYER_UPDATED";

export function timersScoreCards(store) {
  store.on("@init", () => {
    return {
      timersScoreCards: {
        clearScoreCards: [],
        hideScoreCards: [],
        scoreCardToHide: {
          bowlingCenterUUID: null,
          lane: null,
        },
        lastPlayerUpdated: null,
      },
    };
  });

  store.on(
    ADD_TIMER_HIDE_SCORECARD,
    ({ timersScoreCards }, { bowlingCenterUUID, lane }) => {
      const hideScoreCards = [...timersScoreCards.hideScoreCards];
      const index = hideScoreCards.findIndex(
        (item) =>
          item.bowlingCenterUUID === bowlingCenterUUID && item.lane === lane
      );
      if (index > -1) {
        clearTimeout(timersScoreCards.hideScoreCards[index]);
        hideScoreCards[index].timer = setTimeout(() => {
          store.dispatch(SET_BOWLING_CENTER_TO_HIDE, {
            bowlingCenterUUID,
            lane,
          });
        }, 600000);
      } else {
        hideScoreCards.push({
          bowlingCenterUUID: bowlingCenterUUID,
          lane: lane,
          timer: setTimeout(() => {
            store.dispatch(SET_BOWLING_CENTER_TO_HIDE, {
              bowlingCenterUUID,
              lane,
            });
          }, 600000),
        });
      }

      return {
        timersScoreCards: {
          ...timersScoreCards,
          hideScoreCards: [...hideScoreCards],
        },
      };
    }
  );

  store.on(
    SET_BOWLING_CENTER_TO_HIDE,
    ({ timersScoreCards }, { bowlingCenterUUID, lane }) => {
      return {
        timersScoreCards: {
          ...timersScoreCards,
          scoreCardToHide: {
            bowlingCenterUUID: bowlingCenterUUID,
            lane: lane,
          },
        },
      };
    }
  );

  store.on(SET_LAST_PLAYER_UPDATED, ({ timersScoreCards }, { player }) => {
    return {
      timersScoreCards: {
        ...timersScoreCards,
        lastPlayerUpdated: { ...player },
      },
    };
  });
}
